import React from 'react';
import './MediaCard.css';

/**
 * Media card component for external media coverage (articles, interviews, videos)
 * Used in HomePage and NewGraduatePage Media sections
 */
const MediaCard = ({
  title,
  subtitle = '',
  mediaType = 'article', // 'article', 'youtube', 'interview'
  logo = null, // Custom logo/icon
  thumbnail = null, // Image thumbnail
  link,
  backgroundColor = '#ffffff'
}) => {
  const renderMediaLogo = () => {
    const logos = {
      'ceo-voice': (
        <div className="media-logo-text" style={{ color: '#0066cc' }}>
          <span className="media-logo-mark">▶</span> CEO VOICE
        </div>
      ),
      'venture': (
        <div className="media-logo-text" style={{ color: '#ff6b00' }}>
          ベンチャーJP
        </div>
      ),
      'v-tsushin': (
        <div className="media-logo-text" style={{ color: '#333' }}>
          ベンチャー通信
        </div>
      ),
      'youtrust': (
        <div className="media-logo-text" style={{ color: '#00a0e9' }}>
          YOUTRUST
        </div>
      ),
      'youtube': (
        <div className="media-logo-icon media-logo-youtube">
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
          </svg>
        </div>
      ),
      'default': (
        <div className="media-logo-text">
          Media
        </div>
      )
    };
    
    return logo ? logos[logo] || logos.default : logos.default;
  };

  return (
    <a 
      href={link} 
      target="_blank" 
      rel="noopener noreferrer" 
      className="media-card"
      style={{ backgroundColor }}
    >
      <div className="media-card-header">
        {renderMediaLogo()}
      </div>
      
      {thumbnail && (
        <div className="media-card-thumbnail">
          <img src={thumbnail} alt={title} />
        </div>
      )}
      
      <div className="media-card-content">
        {subtitle && <div className="media-card-subtitle">{subtitle}</div>}
        <h3 className="media-card-title">{title}</h3>
      </div>
      
      <div className="media-card-footer">
        <span className="media-card-link-text">詳しく見る</span>
        <svg className="media-card-arrow" viewBox="0 0 10 10" fill="currentColor">
          <path d="M5.845 2.22a.75.75 0 0 1 1.06 0L9.23 4.543c.41.41.41 1.075 0 1.485L6.905 8.352a.75.75 0 0 1-1.06-1.061l1.25-1.251H.75a.75.75 0 0 1 0-1.5h6.354l-1.26-1.26a.75.75 0 0 1 0-1.06Z"/>
        </svg>
      </div>
    </a>
  );
};

export default MediaCard;
